export const formatUrl = (url, parameters) => {
  let result = url;
  Object.keys(parameters).forEach(key => {
    result = result.replace(`:${key}`, parameters[key]);
  });
  return result;
};
